import React from "react";
import hosLogo from "../images/meritt-hospitals.png";

function ComingSoon() {
  return (
    <section
      className="relative w-full h-[100vh] flex items-center justify-center"
      style={{
        backgroundImage:
          "url('https://images.unsplash.com/photo-1538108149393-fbbd81895907?q=80&w=1228&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-50"></div>

      {/* Content */}
      <div className="relative z-10 text-center flex flex-col items-center">
        {/* Hospital Logo */}
        <img
          src={hosLogo}
          alt="Hospital Logo"
          style={{ width: "50%", height: "50%" }}
          className="mb-6 drop-shadow-lg"
        />

        {/* Coming Soon Text */}
        <h1 className="text-white text-4xl md:text-6xl font-bold tracking-wide drop-shadow-lg">
          Coming Soon...
        </h1>

        <p className="text-gray-200 text-lg md:text-xl mt-4">
          Your trusted healthcare destination
        </p>
      </div>
    </section>
  );
}

export default ComingSoon;